import { combineReducers } from 'redux';
import application from './Application';
import general from './General';

export default combineReducers({
  general,
  application,
});
